export default __webpack_public_path__ + "static/media/reg-modal-anim@2x.81a1555e.gif";